import request from '@/utils/request'

export function announcementList (params) {
  return request({
    method: 'get',
    params: {
      r: 'information/lists',
      ...params
    }
  })
}
